module.exports = __webpack_public_path__ + "037e6b8f117e950b207a75c7aaee163c.ttf";